// src/features/services/ServicesPage.tsx
import { useState } from 'react';
import { GlassCard } from '../../app/components/ui/GlassCard';
import { ServiceList } from './components/ServiceList';
import { ServiceWorkspace } from './components/ServiceWorkspace';
import type { Service } from './components/ServiceRow';
import { useServices } from './hooks/useServices';

export function ServicesPage() {
  const { services, loading, error } = useServices();
  const [selectedService, setSelectedService] = useState<Service | null>(null);

  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          سرویس‌ها
        </h1>
        <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
          فهرست سرویس‌های فعال، در حال اتمام و منقضی‌شده مشتریان.
        </p>
      </div>

      {loading ? (
        <GlassCard>
          <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
            در حال دریافت فهرست سرویس‌ها...
          </p>
        </GlassCard>
      ) : error ? (
        <GlassCard>
          <p className="text-sm text-rose-400">{error}</p>
        </GlassCard>
      ) : (
        <GlassCard noPadding>
          <ServiceList
            services={services}
            selectedServiceId={selectedService?.id ?? null}
            onSelectService={setSelectedService}
          />
        </GlassCard>
      )}

      <ServiceWorkspace service={selectedService} onClose={() => setSelectedService(null)} />
    </div>
  );
}
